import { useInfiniteGetAllProjectsQuery } from '../../api/infinite_scroll_index';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useInfiniteGetAllProjects = (variables: any, rowPerPageOptions: any) => {
  const { accessToken, headerWithAuth } = useGetAccessToken();
  const {
    data,
    isFetching,
    isSuccess,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteGetAllProjectsQuery<any>(
    headerWithAuth,
    'args',
    variables,
    {
      // @ts-ignore
      enabled: !!accessToken,
      keepPreviousData: true,
      getNextPageParam: (lastPage: any) => {
        if (lastPage?.getAllProjects?.page?.pageInfo.hasNextPage) {
          return {
            first: rowPerPageOptions?.value,
            after: lastPage?.getAllProjects?.page?.pageInfo?.endCursor,
          };
        }
        return null;
      },
    },
  );

  return {
    data,
    isFetching,
    isSuccess,
    fetchNextPage,
    hasNextPage,
  };
};

export {
  useInfiniteGetAllProjects,
};
